import Modules from '@/models/Modules.js'
import {
  CarbonIntensity,
  CarbonIntensities
} from '@/models/carbon/CarbonIntensity.js'
import { ImpactIntensity } from '@/models/carbon/ImpactIntensity.js'
import { ImpactFactor } from '@/models/carbon/Factor.js'

/** Represent the carbon footprint synthesis of an inventory (travels, building). */
class CarbonSynthesis {
  /**
   * Create a new CarbonSynthesis
   */
  constructor (obj) {
    for (let module of Modules.getModules(true)) {
      this[module] = new CarbonIntensity()
      if (obj) {
        // rationale: set the corresponding CarbonIntensity only if defined
        if (Object.keys(obj).includes(module) && obj[module]) {
          this[module] = CarbonIntensity.createFromObj(obj[module])
        }
      }
    }
  }

  toString (sep = '\t') {
    let values = []
    for (let module of Modules.getModules(true)) {
      values.push(this[module].intensity, this[module].uncertainty)
    }
    return values.join(sep)
  }

  get buildings () {
    let intensities = new CarbonIntensities()
    for (let module of Modules.MODULES[Modules.BUILDINGS]) {
      intensities.add(this[module])
    }
    return intensities.sum()
  }

  get intensity () {
    let intensity = 0.0
    // TODO restrict to modules in settings
    for (let module of Modules.getModules(true)) {
      intensity += this[module].intensity
    }
    return intensity
  }

  get uncertainty () {
    let uncertainty = 0.0
    // TODO restrict to modules in settings
    for (let module of Modules.getModules(true)) {
      uncertainty += this[module].uncertainty
    }
    return uncertainty
  }

  static createFromObj (item) {
    return new CarbonSynthesis(item)
  }

  static exportHeader (sep = '\t') {
    let values = []
    for (let module of Modules.getModules(true)) {
      values.push(module + '.emission.kg.co2e', module + '.uncertainty.kg.co2e')
    }
    return values.join(sep)
  }
}

/** Represent the lca footprint synthesis of an inventory (travels, building). */
class LCASynthesis {
  /**
   * Create a new LCASynthesis
   */
  constructor (obj) {
    for (let module of Modules.getModules(true)) {
      this[module] = new ImpactIntensity()
      if (obj) {
        // rationale: set the corresponding CarbonIntensity only if defined
        if (Object.keys(obj).includes(module) && obj[module]) {
          this[module] = ImpactIntensity.createFromObj(obj[module])
        }
      }
    }
  }

  toString (sep = '\t') {
    let values = []
    for (let module of Modules.getModules(true)) {
      for (let key of ImpactFactor.keys) {
        if (this[module].isEmpty) {
          values.push(0)
        } else if (this[module].hasKey(key)) {
          values.push(this[module].intensity[key])
        } else {
          values.push(0)
        }
      }
    }
    return values.join(sep)
  }

  get buildings () {
    let intensities = new CarbonIntensities()
    for (let module of Modules.MODULES[Modules.BUILDINGS]) {
      intensities.add(this[module])
    }
    return intensities.sum()
  }

  get intensity () {
    let intensity = 0.0
    // TODO restrict to modules in settings
    for (let module of Modules.getModules(true)) {
      intensity += this[module].intensity
    }
    return intensity
  }

  get uncertainty () {
    return 0.0
  }

  static createFromObj (item) {
    return new LCASynthesis(item)
  }

  static exportHeader (sep = '\t') {
    let values = []
    for (let module of Modules.getModules(true)) {
      for (let key of ImpactFactor.keys) {
        values.push(module + '.' + key)
      }
    }
    return values.join(sep)
  }
}

export { CarbonSynthesis, LCASynthesis }
